/** Caps each plain-text message excerpt after HTML sanitisation in the interest context slice. */
export const ASSISTANT_INTEREST_EXCERPT_MAX_CHARACTERS = 2_000;
